(function() {
  function initIngredientBenefitsPopup() {
    const popup = document.getElementById('ingredient-benefits-popup');
    const contentEl = popup && popup.querySelector('.ingredient-benefits-popup__content');
    const titleEl = popup && popup.querySelector('.ingredient-benefits-popup__title');
    const closeTriggers = popup && popup.querySelectorAll('[data-close-popup]');

    if (!popup || !contentEl || !titleEl) return;

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function escapeHtml(text) {
      if (text == null) return '';
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function escapeAttr(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    var circleArrowSvg = '<svg class="ingredient-benefits-popup__link-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true"><circle cx="6.3752" cy="6.37471" r="5.68442" stroke="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.86321 6.69033H3.0002V6.05908H8.86321L6.90201 4.09789L7.34838 3.65153L9.84838 6.15153L10.0716 6.37471L9.84838 6.59789L7.34838 9.09789L6.90201 8.65153L8.86321 6.69033Z" fill="currentColor"/></svg>';

    function openPopup(ingredientName, benefits) {
      titleEl.textContent = ingredientName;
      contentEl.innerHTML = '';

      var rawJson = '';
      try {
        rawJson = JSON.stringify(benefits != null ? benefits : [], null, 2);
      } catch (e) {
        rawJson = String(benefits);
      }

      if (benefits && benefits.length > 0) {
        benefits.forEach(function(benefit) {
          const benefitEl = document.createElement('div');
          benefitEl.className = 'ingredient-benefits-popup__benefit pb-3xl';

          var html = '';
          if (benefit.title) {
            html += '<p class="ingredient-benefits-popup__benefit-title style-p2 font-600 pt-xl pb-sm">' + escapeHtml(benefit.title) + '</p>';
          }
          if (benefit.description) {
            html += '<div class="ingredient-benefits-popup__benefit-desc style-p3 pb-sm">' + escapeHtml(benefit.description) + '</div>';
          }
          if (benefit.links && benefit.links.length > 0) {
            html += '<div class="ingredient-benefits-popup__links gap-lg">';
            benefit.links.forEach(function(link) {
              var anchor = (link.anchor || link.text || link.title || 'Link').trim() || 'Evidence';
              var url = (link.url || link.href || '').trim();
              if (url) {
                html += '<a class="style-eyebrow-2 text-black no-underline uppercase py-sm ingredient-benefits-popup__link gap-tiny" href="' + escapeAttr(url) + '" target="_blank" rel="noopener">' + escapeHtml(anchor) + ' ' + circleArrowSvg + '</a>';
              }
            });
            html += '</div>';
          }
          benefitEl.innerHTML = html;
          contentEl.appendChild(benefitEl);
        });
      } else {
        contentEl.innerHTML = '<p class="style-p3">No benefits listed for this ingredient.</p>';
      }

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    if (closeTriggers && closeTriggers.length) {
      closeTriggers.forEach(function(btn) {
        btn.addEventListener('click', closePopup);
      });
    }

    popup.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closePopup();
    });

    window.openIngredientBenefitsPopup = openPopup;
    window.closeIngredientBenefitsPopup = closePopup;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIngredientBenefitsPopup);
  } else {
    initIngredientBenefitsPopup();
  }
})();
